// Module
var code = "<putlist-form\n    plist=\"plist\"\n    plists=\"plists\"\n    plans=\"plans\"\n    drivers=\"drivers\"\n    avtos=\"avtos\"\n    priceps=\"priceps\"\n    our-firms=\"ourFirms\"\n    on-close=\"$close(plist)\">\n</putlist-form>\n";
// Exports
module.exports = code;